var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.title?_vm.title:'Notification'))]),_c('h4',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.subtitle))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }